export default __webpack_public_path__ + "static/successPredictorHero-6b300b2dbff6d16ffa3af0d681068be2.webp";